import MDInput from "components/MDInput";
import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Alert,
  FormHelperText,
  Checkbox,
  ListItemText,
  ListSubheader,
  Box,
  Grid,
  useTheme,
  useMediaQuery,
  Autocomplete,
  TextField,
} from "@mui/material";
import MDButton from "components/MDButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";

import BackspaceIcon from "@mui/icons-material/Backspace";
import ClearIcon from "@mui/icons-material/Clear";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useMaterialUIController } from "context";
import colors from "assets/theme/base/colors";

export default function Filter({
  dataFilter,
  filter,
  handleFilter,
  isVisible,
  handleChange,
  search,
  filterType,
  handleFilterType,
  isVisibleSelectDateInput,
  isVisibleSelectDate,
  isVisibleType,
  isVisibleSubcategory,
  isVisibleCertifiable,
  isVisibleEnabled,
  isVisibleCategory,
  isVisibleNode,
  isVisibleAuthor,
  dateFrom,
  dateUntil,
  handleChangeDateFrom,
  handleChangeDateUntil,
  handleClickSubmit,
  dataTypeCard,
  dataStatus,
  dataSourceTypes,
  handleAddFilter,
  filters,
  showErrorAlert,
  handleDeleteFilter,
  isFieldValid,
  filterConfig,
  handleFieldChange,
  listSubCategories = [],
  categoriesList = [],
  isVisibleStatus,
  isVisibleErrorType,
  isVisibleSeverity,
  isVisibleGender,
  isVisibleSpecialProtectionGroup,
  isVisibleState,
  gendersList = [],
  specialProtectionGroupsList = [],
  statesList = [],
  isVisibleSemester,
  semesterYear,
  semesterPeriod,
  handleSemesterYearChange,
  handleSemesterPeriodChange,
  nodesList = [],
  usersList = [],
  dataTable,
  getNodeStatusOptions,
}) {
  let { white, black } = colors;

  black = black.main;
  white = white.main;

  // Obtener el estado del tema (modo oscuro/claro)
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  // Hook para obtener el tema y detectar breakpoints responsivos
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Detecta pantallas menores a 960px
  const isTablet = useMediaQuery(theme.breakpoints.down('lg')); // Detecta pantallas menores a 1280px

  const [selectedSubcategories, setSelectedSubcategories] = useState([]);

  // useEffect(() => {
  //   // If you need to perform any action when listSubCategories changes
  // }, [listSubCategories]);

  const handleChangeSubcategory = (event) => {
    const selectedItem = event.target.value[event.target.value.length - 1]; // Obtener el último elemento seleccionado o deseleccionado

    setSelectedSubcategories((prevSelected) => {
      const isAlreadySelected = prevSelected.some((item) => item.id === selectedItem.id);

      if (isAlreadySelected) {
        // Si ya está seleccionado, lo eliminamos (deselección)
        handleFieldChange(
          "subcategories",
          prevSelected.filter((item) => item.id !== selectedItem.id)
        );
        return prevSelected.filter((item) => item.id !== selectedItem.id);
      } else {
        // Si no está seleccionado, lo añadimos (selección)
        handleFieldChange("subcategories", [...prevSelected, selectedItem]);
        return [...prevSelected, selectedItem];
      }
    });
    // handleFieldChange("subcategories", selectedSubcategories);
  };

  const renderSelectGroup = (category) => {
    return [
      <ListSubheader style={{ backgroundColor: darkMode ? "#202940" : white, color: darkMode ? white : black, }} key={category.id}>{category.name}</ListSubheader>,
      ...category.subcategories.map((sub) => (
        <MenuItem key={sub.id} value={{ id: sub.id, name: sub.name }}>
          <Checkbox checked={selectedSubcategories.some((s) => s.id === sub.id)} />
          <ListItemText primary={sub.name} />
        </MenuItem>
      )),
    ];
  };
  return (
    <>
      {/* Contenedor responsivo para filtros activos */}
      {filters.length !== 0 && (
        <Box sx={{
          mt: 2,
          mb: 2,
          ml: 2,
          mr: 2,
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1,
          justifyContent: isMobile ? 'center' : 'flex-start'
        }}>
          {filters.map((item, index) => (
            <MDButton
              endIcon={<BackspaceIcon sx={{ fontSize: '1rem !important' }} />}
              variant="contained"
              color="error"
              size="small"
              key={index}
              sx={{
                minWidth: 'auto',
                fontSize: isMobile ? '0.7rem' : '0.75rem',
                padding: isMobile ? '4px 8px' : '6px 12px',
                '& .MuiButton-endIcon': {
                  marginLeft: '4px'
                }
              }}
              onClick={() => handleDeleteFilter(item.id)}>
              {item.label}
            </MDButton>
          ))}
        </Box>
      )}
      {/* Contenedor principal responsivo para controles de filtro */}
      <Grid container spacing={2} style={{ width: "unset !important" }} alignItems="center" sx={{ mt: 1, ml: 2, mr: 2, alignItems: 'flex-start', gap: 0 }}>
        {/* Selector principal de tipo de filtro - Siempre visible */}
        <Grid item sx={{ pl: '0 !important' }}>
          <FormControl variant="standard" sx={{ minWidth: 120, mr: 1 }}>
            <InputLabel id="demo-simple-select-label">Filtrado por...</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filter}
              label="Filtrado por..."
              onChange={handleFilter}>
              <MenuItem value="">NINGUNO</MenuItem>
              {filterConfig.map((item, index) => (
                <MenuItem key={index} value={item.dbField}>
                  {item.visibleName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* Campo de búsqueda de texto */}
        {isVisible && (
          <>
            <Grid item sx={{ pl: '0 !important', mr: 1 }}>
              <MDInput
                error={!isFieldValid.search}
                helperText={!isFieldValid.search ? "Ingrese un valor." : ""}
                label="Buscar"
                onChange={handleChange}
                value={search}
              />
            </Grid>
            <Grid item sx={{ pl: '0 !important' }}>
              <MDButton
                fullWidth
                variant="gradient"
                size="small"
                color="info"
                onClick={handleAddFilter}>
                Agregar Filtro
              </MDButton>
            </Grid>
          </>
        )}
        {/* Filtros de fecha */}
        {isVisibleSelectDate && (
          <>
            <Grid item sx={{ pl: "0 !important", mr: 1 }}>
              <MDInput
                fullWidth
                type="date"
                label="Desde"
                value={dateFrom}
                onChange={handleChangeDateFrom}
              />
            </Grid>
            <Grid item sx={{ pl: "0 !important", mr: 1 }}>
              <MDInput
                fullWidth
                type="date"
                label="Hasta"
                value={dateUntil}
                onChange={handleChangeDateUntil}
              />
            </Grid>
            <Grid item sx={{ pl: "0 !important" }}>
              <MDButton
                fullWidth
                variant="gradient"
                color="info"
                size="small"
                onClick={handleAddFilter}>
                Agregar Filtro
              </MDButton>
            </Grid>
          </>
        )}

        {/* Filtros de tipo select */}
        {isVisibleType && (
          <>
            {/* Select para "Certificable" */}
            {isVisibleCertifiable && (
              <>
                <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                  <FormControl variant="standard" sx={{ minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-label2">Seleccione...</InputLabel>
                    <Select
                      label="Certificable"
                      labelId="demo-simple-select-label2"
                      id="demo-simple-select223"
                      value={search}
                      onChange={handleFilterType}>
                      <MenuItem value="1">Sí</MenuItem>
                      <MenuItem value="0">No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: "0 !important" }}>
                  <MDButton
                    fullWidth
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {/* Select para "Estado" */}
            {isVisibleEnabled && (
              <>
                <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                  <FormControl
                    variant="standard"
                    sx={{ minWidth: 120 }}>
                    <InputLabel id="enabled-select-label">Seleccione estado...</InputLabel>
                    <Select
                      label="Estado"
                      labelId="enabled-select-label"
                      id="enabled-select"
                      value={search}
                      onChange={handleFilterType}>
                      <MenuItem value="Activo">Activo</MenuItem>
                      <MenuItem value="Inactivo">Inactivo</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: "0 !important" }}>
                  <MDButton
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {isVisibleSubcategory && (
              <>
                <Grid item sx={{ pl: "0 !important", pt: "0 !important", mr: 1 }}>
                  <FormControl
                    variant="standard"
                    sx={{
                      minWidth: 220,
                      maxWidth: 250,
                      width: '100%'
                    }}>
                    <InputLabel id="demo-simple-select-label123">
                      Seleccionar subcategorias
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label123"
                      multiple
                      value={selectedSubcategories}
                      onChange={handleChangeSubcategory}
                      renderValue={(selected) => {
                        const names = selected
                          .map((item) => item.name)
                          .filter((name) => name !== null)
                          .join(", ");
                        return (
                          <div style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '200px'
                          }}>
                            {names}
                          </div>
                        );
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 300, // Limita la altura del menú
                            width: "auto", // Ajusta el ancho dinámicamente según el contenido
                            minWidth: 250, // Define un ancho mínimo para evitar que sea demasiado pequeño
                            whiteSpace: "normal", // Permite que las palabras largas se ajusten en varias líneas
                          },
                        },
                      }}
                      sx={{
                        width: "100%", // Ajusta el ancho del Select
                        height: "42px", // Aumenta la altura del Select
                      }}>
                      {/* Renderiza las opciones de subcategorías */}
                      {listSubCategories.map((c) => renderSelectGroup(c))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: "0 !important" }}>
                  <MDButton
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {isVisibleCategory && (
              <>
                <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                  <FormControl
                    variant="standard"
                    sx={{ minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-label321">Selecciona...</InputLabel>
                    <Select
                      value={JSON.stringify(search) || ""}
                      onChange={handleFilterType}
                      label="Selecciona..."
                      labelId="demo-simple-select-label321"
                      id="demo-simple-select321">
                      <MenuItem value="">Ninguno</MenuItem>
                      {categoriesList.map((item) => (
                        <MenuItem
                          key={item.id}
                          value={JSON.stringify({ id: item.id, name: item.name })}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: "0 !important" }}>
                  <MDButton
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {/* Select para "Género" */}
            {isVisibleGender && (
              <>
                <Grid item sx={{ pl: '0 !important', mr: 1 }}>
                  <FormControl variant="standard" sx={{ minWidth: 120 }}>
                    <InputLabel id="gender-select-label">Seleccione género...</InputLabel>
                    <Select
                      value={search && typeof search === "object" && search.id ? JSON.stringify(search) : ""}
                      onChange={handleFilterType}
                      label="Seleccione género..."
                      labelId="gender-select-label"
                      id="gender-select">
                      <MenuItem value="">Ninguno</MenuItem>
                      {gendersList.map((item) => (
                        <MenuItem
                          key={item.id}
                          value={JSON.stringify({ id: item.id, name: item.name })}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: '0 !important' }}>
                  <MDButton
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {/* Select para "Estado" */}
            {isVisibleState && (
              <>
                <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                  <FormControl variant="standard" sx={{ minWidth: 120 }}>
                    <InputLabel id="state-select-label">Seleccione estado...</InputLabel>
                    <Select
                      value={search && typeof search === "object" && search.id ? JSON.stringify(search) : ""}
                      onChange={handleFilterType}
                      label="Seleccione estado..."
                      labelId="state-select-label"
                      id="state-select">
                      <MenuItem value="">Ninguno</MenuItem>
                      {statesList.map((item) => (
                        <MenuItem
                          key={item.id}
                          value={JSON.stringify({ id: item.id, name: item.name })}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: "0 !important" }}>
                  <MDButton
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {/* Select para "Poblaciones Vulnerables" */}
            {isVisibleSpecialProtectionGroup && (
              <>
                <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                  <FormControl
                    variant="standard"
                    sx={{ minWidth: 120 }}>
                    <InputLabel id="special-protection-select-label">Seleccione...</InputLabel>
                    <Select
                      value={search && typeof search === "object" && search.id ? JSON.stringify(search) : ""}
                      onChange={handleFilterType}
                      label="Seleccione grupo..."
                      labelId="special-protection-select-label"
                      id="special-protection-select">
                      <MenuItem value="">Ninguno</MenuItem>
                      {specialProtectionGroupsList.map((item) => (
                        <MenuItem
                          key={item.id}
                          value={JSON.stringify({ id: item.id, name: item.name })}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: "0 !important" }}>
                  <MDButton
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {/* Select para Nodos */}
            {isVisibleNode && (
              <>
                <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                  <FormControl
                    variant="standard"
                    sx={{ minWidth: 240 }}>
                    <Autocomplete
                      options={nodesList || []}
                      getOptionLabel={(option) =>
                        option
                          ? `${option.name}${option.municipality ? ` - ${option.municipality}` : ""}`
                          : ""
                      }
                      noOptionsText={"No hay resultados"}
                      isOptionEqualToValue={(option, value) => option && value && option.id === value.id}
                      value={search && typeof search === "object" && search.id ? search : null}
                      onChange={(e, value) => {
                        // value is either null or the selected node object
                        handleFieldChange("node", value);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Selecciona nodo..." variant="standard" />
                      )}
                      sx={{ width: 260 }}
                    />
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: "0 !important" }}>
                  <MDButton
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {/* Select para Autor */}
            {isVisibleAuthor && (
              <>
                <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                  <FormControl
                    variant="standard"
                    sx={{ minWidth: 240 }}>
                    <Autocomplete
                      options={usersList || []}
                      getOptionLabel={(option) =>
                        option ? option.full_name : ""
                      }
                      noOptionsText={"No hay resultados"}
                      isOptionEqualToValue={(option, value) => option && value && option.id === value.id}
                      value={search && typeof search === "object" && search.id ? search : null}
                      onChange={(e, value) => {
                        // value is either null or the selected user object
                        handleFieldChange("author", value);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Selecciona autor..." variant="standard" />
                      )}
                      sx={{ width: 260 }}
                    />
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: "0 !important" }}>
                  <MDButton
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {/* Select para "Status" */}
            {isVisibleStatus && (
              <>
                <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                  <FormControl
                    variant="standard"
                    sx={{ minWidth: 120 }}>
                    <InputLabel id="status-select-label">Seleccione estado...</InputLabel>
                    <Select
                      label="Estado"
                      labelId="status-select-label"
                      id="status-select"
                      value={search}
                      onChange={handleFilterType}>
                      <MenuItem value="Procesando">Procesando</MenuItem>
                      <MenuItem value="Completado">Completado</MenuItem>
                      <MenuItem value="Fallido">Fallido</MenuItem>
                      <MenuItem value="Parcialmente exitoso">Parcialmente exitoso</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: "0 !important" }}>
                  <MDButton
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {/* Select para "Error Type" */}
            {isVisibleErrorType && (
              <>
                <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                  <FormControl
                    variant="standard"
                    sx={{ minWidth: 120 }}>
                    <InputLabel id="error-type-select-label">Seleccione tipo de error...</InputLabel>
                    <Select
                      label="Tipo de error"
                      labelId="error-type-select-label"
                      id="error-type-select"
                      value={search}
                      onChange={handleFilterType}>
                      <MenuItem value="Error de validación">Error de validación</MenuItem>
                      <MenuItem value="Registro duplicado">Registro duplicado</MenuItem>
                      <MenuItem value="Datos faltantes">Datos faltantes</MenuItem>
                      <MenuItem value="Formato inválido">Formato inválido</MenuItem>
                      <MenuItem value="Error de referencia">Error de referencia</MenuItem>
                      <MenuItem value="Referencia a celda">Referencia a celda</MenuItem>
                      <MenuItem value="Participante ya existe">Participante ya existe</MenuItem>
                      <MenuItem value="Categoría no encontrada">Categoría no encontrada</MenuItem>
                      <MenuItem value="Error desconocido">Error desconocido</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: "0 !important" }}>
                  <MDButton
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {/* Select para "Severity" */}
            {isVisibleSeverity && (
              <>
                <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                  <FormControl
                    variant="standard"
                    sx={{ minWidth: 120 }}>
                    <InputLabel id="severity-select-label">Seleccione severidad...</InputLabel>
                    <Select
                      label="Severidad"
                      labelId="severity-select-label"
                      id="severity-select"
                      value={search}
                      onChange={handleFilterType}>
                      <MenuItem value="Baja">Baja</MenuItem>
                      <MenuItem value="Media">Media</MenuItem>
                      <MenuItem value="Alta">Alta</MenuItem>
                      <MenuItem value="Crítica">Crítica</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sx={{ pl: "0 !important" }}>
                  <MDButton
                    variant="gradient"
                    size="small"
                    color="info"
                    onClick={handleAddFilter}>
                    Agregar Filtro
                  </MDButton>
                </Grid>
              </>
            )}
            {/* Select para estados de nodos */}
            {dataTable === "nodes" &&
              filter === "active" &&
              !isVisibleSubcategory &&
              !isVisibleCertifiable &&
              !isVisibleCategory &&
              !isVisibleAuthor && (
                <>
                  <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                    <FormControl
                      variant="standard"
                      sx={{ minWidth: 120 }}>
                      <InputLabel id="demo-simple-select-node-status">Estado</InputLabel>
                      <Select
                        labelId="demo-simple-select-node-status"
                        id="demo-simple-select-node-status"
                        value={
                          search && typeof search === "object" && search.id !== undefined
                            ? search.id.toString()
                            : ""
                        }
                        onChange={handleFilterType}
                        label="Estado">
                        <MenuItem value="">Ninguno</MenuItem>
                        {getNodeStatusOptions &&
                          getNodeStatusOptions().map((option) => (
                            <MenuItem key={option.id} value={option.id.toString()}>
                              {option.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sx={{ pl: "0 !important" }}>
                    <MDButton
                      variant="gradient"
                      size="small"
                      color="info"
                      onClick={handleAddFilter}>
                      Agregar Filtro
                    </MDButton>
                  </Grid>
                </>
              )}
            {/* Select por defecto para otros casos que no son específicos */}
            {!isVisibleSubcategory &&
              !isVisibleCertifiable &&
              !isVisibleCategory &&
              !isVisibleNode &&
              !isVisibleAuthor &&
              !isVisibleGender &&
              !isVisibleSpecialProtectionGroup &&
              !isVisibleState &&
              !isVisibleSeverity &&
              !isVisibleErrorType &&
              !isVisibleStatus &&
              !isVisibleEnabled &&
              !(dataTable === "nodes" && filter === "active") && (
                <>
                  <Grid item sx={{ pl: "0 !important", mr: 1 }}>
                    <FormControl
                      variant="standard"
                      sx={{ minWidth: 120 }}>
                      <InputLabel id="demo-simple-select-default">Selecciona...</InputLabel>
                      <Select
                        labelId="demo-simple-select-default"
                        id="demo-simple-select-default"
                        value={search ? JSON.stringify(search) : ""}
                        onChange={handleFilterType}
                        label="Selecciona...">
                        <MenuItem value="">Ninguno</MenuItem>
                        {/* Aquí puedes agregar opciones por defecto si las necesitas */}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sx={{ pl: "0 !important" }}>
                    <MDButton
                      variant="gradient"
                      size="small"
                      color="info"
                      onClick={handleAddFilter}>
                      Agregar Filtro
                    </MDButton>
                  </Grid>
                </>
              )}
          </>
        )}

        {/* Filtro de Semestre - Responsivo */}
        {isVisibleSemester && (
          <>
            <Grid item sx={{ pl: "0 !important", mr: 1 }}>
              <FormControl variant="standard" sx={{ minWidth: 120 }}>
                <InputLabel id="semester-year-label">Año</InputLabel>
                <Select
                  labelId="semester-year-label"
                  value={semesterYear}
                  label="Año"
                  onChange={handleSemesterYearChange}
                >
                  {Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i).map(year => (
                    <MenuItem key={year} value={year}>{year}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item sx={{ pl: "0 !important", mr: 1 }}>
              <FormControl variant="standard" sx={{ minWidth: 120 }}>
                <InputLabel id="semester-period-label">Período</InputLabel>
                <Select
                  labelId="semester-period-label"
                  value={semesterPeriod}
                  label="Período"
                  onChange={handleSemesterPeriodChange}
                >
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item sx={{ pl: "0 !important" }}>
              <MDButton
                variant="gradient"
                size="small"
                color="info"
                onClick={handleAddFilter}>
                Agregar Filtro
              </MDButton>
            </Grid>
          </>
        )}
      </Grid>

      {/* Botón de búsqueda principal - Responsivo */}
      <Box sx={{
        mt: 2,
        mr: 2,
        ml: 2,
        display: 'flex',
        justifyContent: isMobile ? 'center' : 'flex-start',
      }}>
        <MDButton
          variant="gradient"
          color="info"
          size={isMobile ? "medium" : "large"}
          sx={{
            minWidth: isMobile ? '120px' : '120px',
            px: isMobile ? 4 : 3
          }}
          onClick={handleClickSubmit}>
          Buscar
        </MDButton>
      </Box>
    </>
  );
}
